// Generate the last 10 fortnights
const fortnightsArray = [];

const epochDate = new Date("2023-7-30");
const today = new Date();
const old_date = new Date(epochDate);

while (old_date < today) {
    const yyyy_start = old_date.getFullYear();
    const mm_start = String(old_date.getMonth() + 1).padStart(2, '0');
    const dd_start = String(old_date.getDate()).padStart(2, '0');

    old_date.setDate(old_date.getDate() + 14);

    if (old_date < today) {
    
        const yyyy_end = old_date.getFullYear();
        const mm_end = String(old_date.getMonth() + 1).padStart(2, '0');
        const dd_end = String(old_date.getDate()).padStart(2, '0');

        fortnightsArray.push({
            value: `${yyyy_end}-${mm_end}-${dd_end}`,
            label: `${yyyy_start}-${mm_start}-${dd_start} to ${yyyy_end}-${mm_end}-${dd_end}`,
        });
    }
}

// Weeks array logic
const weeksArrayTemp = [];
const weekEpochDate = new Date("2023-7-30");
const todayWeek = new Date();
const week_old_date = new Date(weekEpochDate);

while (week_old_date < todayWeek) {
    const yyyy_start = week_old_date.getFullYear();
    const mm_start = String(week_old_date.getMonth() + 1).padStart(2, '0');
    const dd_start = String(week_old_date.getDate()).padStart(2, '0');

    week_old_date.setDate(week_old_date.getDate() + 7);

    if (week_old_date < todayWeek) {
        const yyyy_end = week_old_date.getFullYear();
        const mm_end = String(week_old_date.getMonth() + 1).padStart(2, '0');
        const dd_end = String(week_old_date.getDate()).padStart(2, '0');

        weeksArrayTemp.push({
            value: `${yyyy_end}-${mm_end}-${dd_end}`,
            label: `w.c. ${yyyy_start}-${mm_start}-${dd_start}`,
        });
    }
}
const weeksArray = weeksArrayTemp.slice(-10).reverse();

export { fortnightsArray, weeksArray };
